import { __ } from "@wordpress/i18n";
import { utils } from "../../../helpers";

/**
 * formatters for the fields
 */
const KNOWN_FORMATTERS: Record<string, (value: any) => string> = {
  ltv: (value) => utils.toRound(value * 100) + "%",
  equityRequired: (value) => utils.toEuro(value),
  downPaymentValue: (value) => utils.toEuro(value),
  loanAmount: (value) => utils.toEuro(value),
  paymentValue: (value) => utils.toEuro(value),
  effortRate: (value) => utils.toRound(value * 100) + "%",
  affordability: (value) => AFFORDABILITY_LABEL[value] ?? value,
  taxesTotal: (value) => utils.toEuro(value),
  fixedCostsTotal: (value) => utils.toEuro(value),
  total: (value) => utils.toEuro(value),
  ITP: (value) => utils.toEuro(value),
  IVA: (value) => utils.toEuro(value),
  IGIC: (value) => utils.toEuro(value),
  IPSI: (value) => utils.toEuro(value),
  AJD: (value) => utils.toEuro(value),
  notaria_registro_gestoria_tasacion: (value) => utils.toEuro(value),
};

/**
 * translatable labels for the fields/keys
 */
const KNOWN_LABELS: Record<string, string> = {
  ltv: __("LTV", "df-simulators"),
  equityRequired: __("Poupança necessária", "df-simulators"),
  downPaymentValue: __("Entrada", "df-simulators"),
  loanAmount: __("Valor do empréstimo", "df-simulators"),
  paymentValue: __("Valor da prestação", "df-simulators"),
  operatingCosts: __("Despesas e impostos", "df-simulators"),
  total: __("Despesas e impostos", "df-simulators"),
  effortRate: __("Taxa de Esforço", "df-simulators"),
  affordability: __("Tem rendimentos suficientes?", "df-simulators"),
  //taxes: __("Impostos", "df-simulators"),
  //taxesTotal: __("Total de impostos", "df-simulators"),
  //fixedCosts: __("Despesas fixas", "df-simulators"),
  //fixedCostsTotal: __("Total de despesas fixas", "df-simulators"),
  //notaria_registro_gestoria_tasacion: __("Notário, registo, gestoria e avaliação", "df-simulators"),
};

const AFFORDABILITY_LABEL = {
  NOT_AFFORDABLE: __("Não", "df-simulators"),
  AFFORDABLE: __("Sim", "df-simulators"),
  AFFORDABLE_WITH_EFFORT: __("Sim, com esforço", "df-simulators"),
}

// /** "somethingLikeThis" / "some_key" -> "Something Like This", used only
//  * for fields with no pt-PT label yet (i.e. not yet in KNOWN_LABELS above)
//  * since the API contract isn't final. */
// const humanizeKey = (key: string): string =>
//   key
//     .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
//     .replace(/_/g, " ")
//     .replace(/^./, (char) => char.toUpperCase());

export interface ResultRow {
  label: string;
  value: string;
}

/**
 * Flattens a scenario object into label/value rows.
 * Keys without a KNOWN_LABELS entry are ignored.
 */
export const flattenResultRows = (
  data: Record<string, any>,
  prefix = "",
): ResultRow[] => {
  return Object.entries(data || {}).flatMap(([key, value]) => {
    const knownLabel = KNOWN_LABELS[key];

    // const displayLabel = knownLabel || humanizeKey(key);
    // const label = knownLabel
    //   ? displayLabel
    //   : prefix
    //     ? `${prefix} — ${displayLabel}`
    //     : displayLabel;

    if (!knownLabel) {
      return [];
    }

    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      return flattenResultRows(value, knownLabel);
    }

    const format = KNOWN_FORMATTERS[key];
    return [{ label: knownLabel, value: format ? format(value) : String(value) }];
  });
};
